"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Order = exports.OrderSide = void 0;
const anchor_1 = require("@project-serum/anchor");
const big_js_1 = __importDefault(require("big.js"));
const mobx_1 = require("mobx");
var OrderSide;
(function (OrderSide) {
    OrderSide["Buy"] = "buy";
    OrderSide["Sell"] = "sell";
})(OrderSide = exports.OrderSide || (exports.OrderSide = {}));
class Order {
    constructor(order) {
        this.id = '';
        this.orderType = OrderSide.Buy;
        this.orderMint = '';
        this.currencyMint = '';
        this.currencyDecimals = 0;
        this.price = new anchor_1.BN(0);
        this.orderQtyRemaining = 0;
        this.orderOriginationQty = 0;
        this.owner = '';
        this.ownerAssetTokenAccount = '';
        this.ownerCurrencyTokenAccount = '';
        this.createdAt = 0;
        this.slotContext = 0;
        if (order) {
            this.id = order.id;
            this.orderType = order.orderType;
            this.orderMint = order.orderMint;
            this.currencyMint = order.currencyMint;
            this.currencyDecimals = order.currencyDecimals;
            this.price = order.price;
            this.orderQtyRemaining = order.orderQtyRemaining;
            this.orderOriginationQty = order.orderOriginationQty;
            this.owner = order.owner;
            this.ownerAssetTokenAccount = order.ownerAssetTokenAccount;
            this.ownerCurrencyTokenAccount = order.ownerCurrencyTokenAccount;
            this.createdAt = order.createdAt;
            this.slotContext = order.slotContext;
        }
        (0, mobx_1.makeObservable)(this, {
            orderQtyRemaining: mobx_1.observable,
        });
    }
    get decimalDivisor() {
        return new big_js_1.default(10).pow(this.currencyDecimals);
    }
    get bigNumberPrice() {
        return new big_js_1.default(this.price.toString());
    }
    get uiPrice() {
        return this.bigNumberPrice.div(this.decimalDivisor).toNumber();
    }
    priceForQuantity(quantity = 1) {
        return this.bigNumberPrice
            .mul(quantity)
            .div(this.decimalDivisor)
            .toNumber();
    }
}
exports.Order = Order;
//# sourceMappingURL=Order.js.map